// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectReportMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { BusinessRejectMessage } from '../Messages/BusinessRejectMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
import { BusinessRejectErrorDictionary } from '@shared/commons/BusinessRejectUtils/BusinessRejectUtils';
import { ReportMessageSource } from '@shared/utils/Enums/Constants';
export class BusinessRejectMessageProcessor extends MessageProcessorBase {
    // TODO. WIP. Refactor. Business reject should be treated differently.
    // Here's workaround for now: creating of report message from business reject message.
    decode(fieldSet) {
        const rejectMsg = new BusinessRejectMessage(fieldSet);
        const reportMessage = new DirectReportMessage();
        const errorCode = fieldSet.GetValue(FieldsFactory.FIELD_ERROR_CODE);
        reportMessage.Name = this.getMessageName(errorCode);
        reportMessage.BusinessRejectCode = errorCode;
        reportMessage.source = ReportMessageSource.BusinessRejectMessage;
        let comment = rejectMsg.getComment();
        const tmpComment = BusinessRejectErrorDictionary[reportMessage.BusinessRejectCode];
        if (tmpComment) {
            comment = tmpComment;
        }
        reportMessage.Data = [['Error', comment]];
        reportMessage.reject = true;
        return [reportMessage];
    }
    getMessageName(errorCode) {
        if (errorCode === BusinessRejectMessage.OPTION_EXERCISE_ONLY_ITM) {
            return 'general.trading.PositionExerciseReject';
        }
        return 'general.trading.refused';
    }
}
